// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import cartReducer from './slices/cart';
import menuReducer from './slices/menu';
import sliceOportunidad from './slices/oportunidad';
import snackbarReducer from './slices/snackbar';
import userReducer from './slices/user';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    cart: persistReducer(
        {
            key: 'cart',
            storage,
            keyPrefix: 'berry-'
        },
        cartReducer
    ),
    // auth: authReducer,
    snackbar: snackbarReducer,
    user: userReducer,
    menu: menuReducer,
    oportunidad: sliceOportunidad,
});

export default reducer;
